import type { FaireProductEntity } from "../../entity_types/product";

export const p_qj5mvsmf5g: FaireProductEntity = {
  token: "p_qj5mvsmf5g",
  type: "product",
  name: "Large Beach Tote Bag With Lines (+4 CT)",
  brandToken: "b_evs5oljf5i",
  brandName: "Suzie Q USA",
  imageUrl:
    "https://cdn.faire.com/fastly/221a28b78e215e1f2ce9231af99f2738abecd6b1f0eacb3e244857520b82f12e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/658344b6f8e771448b0cb6766919251b3f35adfc0e841a0e0d2ab8f7ebd70471.jpeg",
    "https://cdn.faire.com/fastly/d678dc8734d83e5c8c3b4b863b2b8f81225dd3ea05c532040be25b845a8bab18.jpeg",
    "https://cdn.faire.com/fastly/ba311016550275041f3fb6dd57868a1c6ab70117ca6fc50c93611f30d17178f3.jpeg",
    "https://cdn.faire.com/fastly/f41754a7ba285251ca92c1431ad5d8a9d41649048973422496dbef0bed610f54.jpeg",
    "https://cdn.faire.com/fastly/80b1f28b086f9cd9ff948eba5645bf3e66b73158b9910beafe6684ec07f3ab32.jpeg",
    "https://cdn.faire.com/fastly/4ef16e281890bbb2854051a34ba35a43ec81ddd7632c0b51abd559356bf559e7.jpeg",
    "https://cdn.faire.com/fastly/03e0e385cf298fea278ca6f58f2a2ebcc6176bfbdf4d3bacf6c2ccc57c24ac3b.jpeg",
    "https://cdn.faire.com/fastly/cfddfef1d7eddff20b407748d2a9121f7f8b7e28d51722566c62f165125e9d81.jpeg",
    "https://cdn.faire.com/fastly/06f1544f3fd3dfe339a815423ebd3bd401bbb891f1e682226857d329bbac4624.jpeg",
    "https://cdn.faire.com/fastly/7805a55c5627f8c35ce8c65d3807886404100c9dfb1e2dba9ed9dd76180c194c.jpeg",
    "https://cdn.faire.com/fastly/7f934af599fdd927fb65fd3804343035993e885eeb85ae68d30315fbc0314492.jpeg",
    "https://cdn.faire.com/fastly/ea5ac23879a54050433a528d372eaf2864f24d952c56a8b8ca329968c963791c.png",
    "https://cdn.faire.com/fastly/38aca97851d28cf28421b5afb036b08580ea1f88379463a877aaceb10a120b7a.jpeg",
    "https://cdn.faire.com/fastly/a117437836a87f5c749fd9eef1f8d17dd58a09e286715d29fe58db45fbf8d8a0.jpeg",
    "https://cdn.faire.com/fastly/a1fe2d8b00113da952b85e4723594183e9df6947b0c7e5f154aefa801752e38b.jpeg",
  ],
  priceDollars: 28.95,
  description:
    "Meet your new go-to carryall: our tote bag combines durability, function, and style perfect for beach days, grocery runs, or everyday errands. Crafted from lightweight, waterproof EVA material.\nSize: 18 in x 14 in x 10 in \nStrap Length: 28 in ",
  tags: [],
  msrpDollars: 57.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:12.140Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
